import { render, staticRenderFns } from "./PromoList.vue?vue&type=template&id=081120fa"
import script from "./PromoList.vue?vue&type=script&lang=js"
export * from "./PromoList.vue?vue&type=script&lang=js"
import style0 from "./PromoList.vue?vue&type=style&index=0&id=081120fa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports